import { attr, BaseModel } from "../../lib/itn-ui-kit/data";

export default class CaseInjuriesModel extends BaseModel {
  static urlPath = "case_reviews";

  @attr("number") clientPainLevel;
  @attr("array") injuries;
  @attr("json") createdBy;
  @attr("json") updatedBy;
  @attr("string") createdAt;
  @attr("string") updatedAt;
  @attr("number") case;
}
